<template>
  <div :id="_uid" class="ui mini modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Adicionar Vencimento" : "Alterar Vencimento " }}
    </div>
    <div class="content">
      <div class="ui form" :class="{ loading }">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Data do Vencimento <span class="red text">*</span></label>
            <date-picker ref="dueDatePicker" :autoInit="false" @onChange="onChangeDueDate" />
          </div>
        </div>
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Valor <span class="red text">*</span></label>
            <input class="money" :value="receivableValue" @blur="receivableValue = $event.target.value">
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Cancelar
      </button>            
      <button class="ui blue button" @click="onConfirm()">
        <i class="checkmark icon"></i> Confirmar
      </button>
    </div>
  </div>
</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import DatePicker from "@/components/date-picker"
  import Input from "@/utils/input"

  export default {
    
    name: "CustomerInvoiceReceivableModal",

    mixins: [modalDialog],

    data() {
      return {
        receivable: {
          dueDate: null,
          value: null,
        }
      }
    },

    components: {
      DatePicker,
    },

    mounted() {
      Input.maskCurrency()
    },

    computed: {
      receivableValue: {
        get() {
          return Input.currencyToString(this.receivable.value)
        },
        set(value) {
          this.receivable.value = Input.stringToCurrency(value)
        },
      },
    },

    methods: {

      load(receivable) {

        this.loading = true
        this.receivable = { dueDate: null, value: null }

        this.$refs.dueDatePicker.clearDate()

        if (receivable)
          this.receivable = this.$cloneObject(receivable)

        this.show()
      },

      onVisible() {

        this.$refs.dueDatePicker.initCalendar({ force: true })

        if (this.isUpdating)
          this.$refs.dueDatePicker.setDate(this.receivable.dueDate)

        this.loading = false  
      },

      onChangeDueDate(date) {
        this.$set(this.receivable, "dueDate", date)
      },

      onConfirm() {

        if (!this.receivable.dueDate || !this.receivable.value)
          return this.$msg.info("Informe o vencimento e o valor da parcela")

        this.emit(this.isCreating ? "onCreate" : "onUpdate", this.$cloneObject(this.receivable))
      },
    },
  }

</script>